import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import {type IAttributeTemplate} from '../schema';

/**
 * `getAttributeTemplates` request
 * (what gets sent to the server)
 */
export type GetAttributeTemplatesRequest = [];

/**
 * `getAttributeTemplates` response
 * (what comes back from the server)
 */
export type GetAttributeTemplatesResponse =
	SuccessResponse<GetAttributeTemplatesResult>;

/**
 * `getAttributeTemplates` result
 * (what is utilized from the server response)
 */
export type GetAttributeTemplatesResult = IAttributeTemplate[];

export const getAttributeTemplatesEndpoint = 'getAttributeTemplates';

/**
 * Get attribute templates
 */
export const getAttributeTemplates = async () => {
	const client = NetxQueryClient();

	const requestParams: GetAttributeTemplatesRequest = [];

	return client
		.post<GetAttributeTemplatesResponse>(
			getAttributeTemplatesEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default getAttributeTemplates;
